import { render, staticRenderFns } from "./HomeUAT.vue?vue&type=template&id=6a9a995b"
import script from "./HomeUAT.vue?vue&type=script&lang=js"
export * from "./HomeUAT.vue?vue&type=script&lang=js"
import style0 from "./HomeUAT.vue?vue&type=style&index=0&id=6a9a995b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports